"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const TimeOnly_1 = tslib_1.__importDefault(require("../../fields/TimeOnly"));
const KeyboardEventCodes_1 = require("../../util/KeyboardEventCodes");
/**
 * @deprecated use {@link WCAGTimeField} instead
 */
class TimeField extends InputWidget_1.default {
    constructor(allowEmptyTime = true) {
        super();
        this.allowEmptyTime = allowEmptyTime;
        this.init();
    }
    isValid() {
        const text = this.getInput().value;
        if (this.allowEmptyTime && fmko_ts_common_1.StringUtils.isEmpty(text)) {
            return true;
        }
        return this._isValid(text, false);
    }
    parseValueFromInput(text) {
        if (fmko_ts_common_1.StringUtils.isEmpty(text)) {
            return null;
        }
        else {
            return TimeOnly_1.default.fromXmlTimeValue(text);
        }
    }
    decorateElement(element) {
        element.type = "text";
        element.classList.add("field", "timeField");
        element.maxLength = 5;
        element.addEventListener("focus", () => element.select());
    }
    setValueOnInput(value, input) {
        this.getInput().value = !value ? "" : value.getStringValue();
    }
    init() {
        this.getInput().addEventListener("keypress", (e) => {
            const textBox = e.target;
            let ch = (0, KeyboardEventCodes_1.getChar)(e);
            if (ch === ".") {
                // Allow ".". Replace with ":" in ValueChangeHandler below..
                ch = ":";
            }
            if (ch === ":") {
                e.preventDefault();
            }
            const pos = textBox.selectionStart;
            if (!this.isValidNextChar(textBox.value, ch, pos)) {
                if (pos === 1 && ch === ":") {
                    // 1 + ":" -> 01:
                    const oldVal = textBox.value;
                    textBox.value = oldVal.substring(0, oldVal.length - 1)
                        + "0" + oldVal.substring(oldVal.length - 1, oldVal.length);
                }
                else {
                    // Illegal character at this point
                    e.preventDefault();
                    return;
                }
            }
            else {
                if (textBox.value.length === pos) {
                    // Cursor is at end of text
                    if (pos === 1) {
                        // Auto append ":" character
                        ch = ":";
                    }
                }
            }
            if (ch === ":") {
                setTimeout(() => {
                    textBox.value = `${textBox.value}:`;
                    if (textBox.value.length === 3) {
                        // Only minutes are missing now - auto append "00", and make them selected
                        textBox.value = `${textBox.value}00`;
                        textBox.setSelectionRange(3, 5);
                    }
                });
            }
        });
        this.getInput().addEventListener("blur", () => this.fixTime());
        this.getInput().addEventListener("paste", () => this.fixTime());
    }
    fixTime() {
        const val = this.getInput().value;
        if (val != null) {
            let v = val.replace(".", ":");
            // Check if all digits
            if (fmko_ts_common_1.StringUtils.onlyContainsDigits(v) && v.length === 4) {
                // hhmm -> hh:mm
                v = v.substring(0, 2) + ":" + v.substring(2);
            }
            else {
                // Convert 1:12 -> 01:12
                if (v.length >= 3) {
                    if (fmko_ts_common_1.StringUtils.onlyContainsDigits(v.charAt(0)) && v.charAt(1) === ":") {
                        v = "0" + v;
                    }
                }
                // Convert 1 -> 01
                if (v.length === 1 && fmko_ts_common_1.StringUtils.onlyContainsDigits(v.charAt(0))) {
                    v = "0" + v;
                }
                if ((v.length === 2 || v.length === 3) && this._isValid(v, true)) {
                    // Valid hour but minutes are missing
                    if (v.length === 2) {
                        v += ":";
                    }
                    v = v + "00";
                }
            }
            if (val !== v && this._isValid(v, true)) {
                this.getInput().value = v;
            }
        }
        const newValue = this.parseValueFromInput(this.getInput().value);
        fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, this.value, newValue);
        this.value = newValue;
    }
    isValidNextChar(oldValue, ch, cursorPos) {
        if ((ch < "0" || ch > "9") && ch !== ":") {
            return false;
        }
        switch (cursorPos) {
            case 0:
            case 1:
                return ch !== ":";
            case 2:
                return ch === ":";
            case 3:
            case 4:
                return ch !== ":";
            case 5:
                return false;
            default:
                return false;
        }
    }
    _isValid(value, acceptPartial) {
        if (acceptPartial) {
            const chars = value.split("");
            let s = "";
            for (let ch of chars) {
                if (!this.isValidNextChar(s, ch, s.length)) {
                    return false;
                }
                s += ch;
            }
            return true;
        }
        // DateTimeFormat is too forgiving..
        const hour = parseInt(value.substring(0, 2), 10);
        if (hour < 0 || hour > 23) {
            return false;
        }
        const minutes = parseInt(value.substring(3, 5), 10);
        if (minutes < 0 || minutes > 59) {
            return false;
        }
        return true;
    }
}
exports.default = TimeField;
//# sourceMappingURL=TimeField.js.map